import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./dashboard.css";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import "react-image-crop/dist/ReactCrop.css";
import { Modal } from "@material-ui/core";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Network } from "../../config/axios";
import { checkEmailFormate } from "../../utils/function";

const MarketingEmailModal = (props) => {
  const { t } = useTranslation();
  let lang = localStorage.getItem("lang");
  const token = localStorage.getItem("token");
  const formValueInit = {
    email: "",
    marketingTerms: false,
  };

  const [formValue, setFormValue] = useState(formValueInit);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormValue({
      ...formValue,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, marketingTerms } = formValue;

    if (!email) {
      toast.error(t("Please enter email address"), { toastId: "email" });
      return;
    }

    const isEmailCorrect = checkEmailFormate(email);
    if (!isEmailCorrect) {
      toast.error(t("Please enter a valid email address"), {
        toastId: "invalidEmail",
      });
      return;
    }

    if (!marketingTerms) {
      toast.error(
        t(
          "The terms of service and delivery of medical information must be approved"
        ),
        { toastId: "marketingTerms" }
      );
      return;
    }

    handleFormSubmit();
  };

  const handleFormSubmit = async () => {
    const data = {
      email: formValue.email,
      marketingTerms: true,
    };
    setLoading(true);
    try {
      const response = await Network().post("/users/acceptMarketingEmail", data, {
        headers: {
          authorization: token,
          "Content-Type": "application/json",
        },
      });
      if ([200, 201, 202].includes(response?.status)) {
        toast.success(t(response?.data?.msg), {
          toastId: "marketEmailSuccess",
        });
        localStorage.setItem("isEmailModal", true);
        props.setShow(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    props.setShow(false);
    localStorage.setItem("isEmailModal", true);
  }

  return (
    <div>
      <Modal
        open={props.show}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="marketing-modal modalContent"
        onClose={() => handleCloseModal()}
      >
        <MDBCard className="modal_card">
          <MDBCardBody>
            <h1>{t("Can I leave you some health in an email?")}</h1>
            <div className="marketing-form">
              <Form onSubmit={handleSubmit}>
                <h6>
                  {t(
                    "To receive a 5% discount on your first private consultation, please enter your email address and confirm receipt of promotional (and interesting ;)) content by email."
                  )}{" "}
                </h6>
                <Form.Group className="form-group">
                  <Form.Control
                    name="email"
                    type="email"
                    id="email"
                    value={formValue.email}
                    placeholder={t("Enter Email")}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Check
                  type="checkbox"
                  label={t("I agree")}
                  name="marketingTerms"
                  className={lang === "EN" ? "checkleft" : "checkright"}
                  checked={formValue?.marketingTerms || false}
                  onChange={handleChange}
                />

                <p>
                  {t(
                    "*** The benefit is provided on our mediation services with Hidoc doctors and not on the medical service itself. The benefit will not be provided on services of doctors working with Hidoc's digital prescription product."
                  )}
                </p>

                <div className="marketing-btn-grid">
                  <Button
                    variant="primary"
                    size="lg"
                    type="submit"
                    disabled={loading}
                  >
                    {t("Submit")}
                  </Button>
                  <Button
                    className="border-btn"
                    variant="secondary"
                    size="lg"
                    type="button"
                    onClick={() => handleCloseModal()}
                  >
                    {t("Close")}
                  </Button>
                </div>
                <span>{t("Information that you have provided and will provide, with your consent and consent, will be stored by Valor (Hidoc) and used by us for the purpose of direct mailing, data analysis and providing services. The information will be transferred to business partners and suppliers (including doctors) for the aforementioned purposes")} </span>
              </Form>
            </div>
          </MDBCardBody>
        </MDBCard>
      </Modal>
    </div>
  );
};
export default MarketingEmailModal;
